import Hls from 'hls.js';

export default function(){
	/* Videos play */
	const videos = document.querySelectorAll( '[data-name="hls-video"]' )

	if ( videos.length > 0 ) {
		videos.forEach( video => {
			const videoSrc = video.getAttribute('data-source')
	
			// HLS video
			if (Hls.isSupported()) {
				var hls = new Hls({
					debug: false,
				});
	
				hls.loadSource(videoSrc);
	
				hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
					const availableQualities = hls.levels.map(level => level.bitrate);
					//const minBitrateThreshold = 720 * 1024; // Minimum bitrate for 720p (in bits per second)
					const minBitrateThreshold = 480 * 1024; // Minimum bitrate for 480p (in bits per second)
			
					let selectedQualityIndex = -1;
			
					// Find the highest quality level that meets or exceeds the minimum bitrate threshold
					for (let i = availableQualities.length - 1; i >= 0; i--) {
						if (availableQualities[i] >= minBitrateThreshold) {
							selectedQualityIndex = i;
							break;
						}
					}
			
					// If no quality level meets the threshold, select the lowest available quality
					if (selectedQualityIndex === -1) {
						selectedQualityIndex = 0;
					}
			
					// Set the selected quality level
					hls.currentLevel = selectedQualityIndex;
				});
	
				hls.attachMedia(video);
				hls.on(Hls.Events.MEDIA_ATTACHED, function () {
					video.muted = true;
					video.play();
				});
			}
			// hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
			// When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
			// This is using the built-in support of the plain video element, without using hls.js.
			else if (video.canPlayType('application/vnd.apple.mpegurl')) {
				video.src = videoSrc;
				video.addEventListener('canplay', function () {
					video.play();
				});
			}
		})
	}
}